import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useElementTracking } from "../../../analytics/analytics";

import type { ElementTracking } from "../../../analytics/analytics";
import type { FieldValues, Path } from "react-hook-form";

interface Props<TFieldValues extends FieldValues> {
  name: Path<TFieldValues>;
}

export const CeAlign = <TFieldValues extends FieldValues>({
  name,
  analyticsCategory,
}: Props<TFieldValues> & ElementTracking): React.JSX.Element => {
  const { control } = useFormContext<TFieldValues>();
  const analyticsPropsLeft = useElementTracking(analyticsCategory, name, "align", "left");
  const analyticsPropsCenter = useElementTracking(analyticsCategory, name, "align", "center");
  const analyticsPropsRight = useElementTracking(analyticsCategory, name, "align", "right");
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl>
          <FormLabel>Align</FormLabel>
          <RadioGroup row {...field}>
            <FormControlLabel
              value="left"
              control={<Radio />}
              label="Left"
              {...analyticsPropsLeft}
            />
            <FormControlLabel
              value="center"
              control={<Radio />}
              label="Center"
              {...analyticsPropsCenter}
            />
            <FormControlLabel
              value="right"
              control={<Radio />}
              label="Right"
              {...analyticsPropsRight}
            />
          </RadioGroup>
          {error && (
            <Typography variant="caption" color="error">
              {error.message}
            </Typography>
          )}
        </FormControl>
      )}
    />
  );
};
